<script >

	import CompanyColaborators from "../../Company/Colaborators/index.svelte";
	import TableFilters from "../../Batch/TableFilters/index.svelte";
	import {setState, getState} from "../../../../stores.js";

	export let navSelected = '';

	export let colaboratorsList = null;

	export let batchFilter = null;

	export let addNewBatch;

	

</script>

	<div class="topContainer">
		
	</div>

	<div class="midContainer">
				
		{#if navSelected == 0} <!-- Company Info  --> 

		
				<CompanyColaborators colaboratorsList={colaboratorsList}/>
		
		{:else if navSelected == 1} <!--Products -->			

		{:else if navSelected == 2} <!--Batch Data -->

			{#if addNewBatch == false && addNewBatch != null && addNewBatch != undefined }

				<TableFilters bind:batchFilter={batchFilter}/>
			{/if}

		{:else if navSelected == 3} <!-- User Info  -->

		{:else if navSelected == 4} <!--Data Analysis -->

		{:else}
			<div>Error</div>
		{/if}
	</div>

	<div class="botContainer">
		
	</div>

<style>
	
	.midContainer{
		width: 100%;
		height: 91%;
	}



	.botContainer{
		width: 100%;
		height: 9%;
	}


</style>
